import { useRequest } from 'ahooks';
// import { useState } from 'react';
import { queryUserService } from './services';

export default function SystemLogModel() {
  //   const [selectedRole, setSelectedRole] = useState<any>(null);

  const { data = { userList: [] }, run: queryUsers } = useRequest(
    queryUserService,
    {
      manual: true,
    },
  );

  return {
    queryUsers,
    userList: data.userList,
  };
}
